// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-text[data-v-6ced8ac0]{display:flex;align-items:center;grid-gap:5px;gap:5px}", ""]);
// Exports
module.exports = exports;
